import './loading.css';

export const Loading = () => {
    return (
        <div className="loader">
        <span> {'{'} </span> 
        <span> {'}'}  </span>
        </div>
    )
}
export default Loading